export default __webpack_public_path__ + "static/media/grafema_tour-guide-cale-do-oiro_02.7bb0ecbd.jpg";